import { buildUrl, handleResponse } from "./auth";

export const getLocationEquipment = (locationId) =>
  fetch(buildUrl(`/api/locations/${locationId}/equipment`)).then(handleResponse);

export const getLocations = (params = {}) => {
  const query = params.includeEquipment ? "?includeEquipment=true" : "";
  return fetch(buildUrl(`/api/locations${query}`)).then(handleResponse);
};

const locationsApi = {
  getLocations,
  getLocationEquipment,
};

export default locationsApi;
